export default {
    MARKETING: "MARKETING",
    INTEGRATION: "INTEGRATION",
    CONFIGURATION: "CONFIGURATION",
    EXTENSION: "EXTENSION",
};
